import { minfinUa } from 'assets/images';

const DESKTOP_MIN_WIDTH = 768;
const DESKTOP_WATERMARK_HEIGHT = 24;

export const CHART_WATERMARK_OFFSET = 16;
export const CHART_WATERMARK_IMAGE = minfinUa;

export const getChartWatermarkHeight = chartWidth => {
  if (chartWidth >= DESKTOP_MIN_WIDTH) {
    return DESKTOP_WATERMARK_HEIGHT;
  }

  return Math.max(
    16,
    Math.round((chartWidth / DESKTOP_MIN_WIDTH) * DESKTOP_WATERMARK_HEIGHT)
  );
};

export const getChartWatermarkCoords = ({
  chartWidth,
  chartLeft,
  chartBottom,
}) => {
  const height = getChartWatermarkHeight(chartWidth);

  return {
    x: chartLeft + CHART_WATERMARK_OFFSET,
    y: chartBottom - height - CHART_WATERMARK_OFFSET,
    height,
  };
};
